<template>
  <div class="course-card" @click="navigateToOverview">
    <div class="card-image">
      <img :src="thumbnailUrl" :alt="productVariantTitle" @error="onImageError" />
      <div v-if="hasExpiry" class="expiry-badge">
        <i class="fas fa-clock"></i> Expires At: {{ expiryDate }}
      </div>
    </div>
    <div class="card-content">
      <h4 class="card-title">{{ productTitle }}</h4>
      <label class="card-subtitle text-muted">{{productVariantTitle}}</label>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: 'ProductCard',
    props: {
      variant: { type: Object, required: true },
    },
    computed: {
      thumbnailUrl() {
        return this.variant.productVariantThumbnailPath ||
               this.variant.product?.productThumbnailPath ||
               require('@/assets/images/sample-thumbnail.jpeg');
      },
      productTitle() {
        return this.variant.product?.productTitle || 'Untitled';
      },
      productVariantTitle() {
        return this.variant.productVariantTitle || '';
      },
      expiryDate() {
        const date = this.variant.expiresAt ? new Date(this.variant.expiresAt) :
                     this.variant.endDate ? new Date(this.variant.endDate) : null;
        return date ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : 'N/A';
      },
      hasExpiry() {
        return !!this.variant.expiresAt || !!this.variant.endDate;
      }
    },
    methods: {
      onImageError(event) {
        event.target.src = require('@/assets/images/sample-thumbnail.jpeg');
        // console.warn(`Image failed to load for variant ${this.variant.productVariantID}`);
      },
      navigateToOverview() {
        this.$emit('navigate-to-overview', this.variant.productVariantID);
      },
    },
  };
  </script>
  
  <style scoped>
  .course-card {
    flex: 0 0 30%;
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .course-card:hover{
    cursor: pointer;
  }
  
  .card-image {
    position: relative;
    width: 100%;
    height: 200px;
  }
  
  .card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .btn-action{
    display: flex;
    justify-content: space-between;
  }
  
  .expiry-badge {
    position: absolute;
    top: 5%;
    left: 5%;
    background-color: #fff;
    padding: 0.5rem;
    border-radius: 15px;
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    color: #ff0000;
  }
  
  .expiry-badge i {
    margin-right: 0.5rem;
  }
  
  .card-content {
    padding: 1rem;
  }
  
  .card-title {
    font-size: 1.1rem;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  
  @media (max-width: 1200px) {
    .course-card {
      flex: 0 0 44%;
    }
  }
  
  @media (max-width: 768px) {
    .course-card {
      flex: 0 0 100%;
    }
  }
  </style>